import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>&copy; {new Date().getFullYear()} agiagent.dev - Premium Domain For Sale</p>
    </footer>
  );
};

export default Footer; 